import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { sessionStore } from '../../sharedStores/sessionStore'
import { trpc } from '../../utils/trpc'

export const useSessionRestore = () => {
	const { isLoggedIn } = sessionStore()

	const query = useQuery({
		...trpc.client.auth.getCurrentUser.queryOptions(),
		enabled: true,
		retry: false,
		staleTime: 30 * 60 * 1000,
	})

	// biome-ignore lint/correctness/useExhaustiveDependencies: dataUpdatedAt is an intentional stable proxy to avoid re-renders from signed URL referential inequality in query.data
	useEffect(() => {
		if (query.isSuccess && query.data?.success && query.data.user) {
			sessionStore.getState().login(query.data.user)
		}
	}, [query.dataUpdatedAt])

	const isRestoring = !isLoggedIn && !query.isSuccess && !query.isError

	return { isRestoring }
}
